import { combineReducers } from "redux";
import cartReducer from "./cart";
import favReducer from "./fav";
import filterReducer from "./filter";
import itemReducer from "./item";
import orderReducer from "./order";
import userReducer from "./user";

const rootReducer = combineReducers({
  user: userReducer,
  item: itemReducer,
  filter: filterReducer,
  fav: favReducer,
  cart: cartReducer,
  order: orderReducer,
});

export default rootReducer;
